export const GET_AGREEMENT_CHECK_SUCCESS = 'GET_AGREEMENT_CHECK_SUCCESS';
export const MAKE_AGREEMENT_SIGN_SUCCESS = 'MAKE_AGREEMENT_SIGN_SUCCESS';
export const GET_AGREEMENT_SUCCESS = 'GET_AGREEMENT_SUCCESS';
export const SET_IS_REQUEST_STATUS = 'SET_IS_REQUEST_STATUS';
